import { LLM_BASE_URL } from '@/constants/configConstants';

export const QUICK_START_ROUTE = 'quick-start';
export const GET_STARTED_ROUTE = 'get-started';

export enum APPLICATION_TYPE {
  em = 'EM',
  llm = 'LLM'
}

export const LLM_APPLICATION_URL = LLM_BASE_URL || '/opik/';
